import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";

export interface ExpertProfileFieldsProps {
  credentials: string;
  onCredentialsChange: (v: string) => void;
  bio: string;
  onBioChange: (v: string) => void;
  disabled?: boolean;
  credentialsError?: string;
  bioError?: string;
}

/** Credentials and bio fields for an expert profile. Both are required for publication. */
export function ExpertProfileFields({
  credentials,
  onCredentialsChange,
  bio,
  onBioChange,
  disabled,
  credentialsError,
  bioError,
}: ExpertProfileFieldsProps) {
  const { t } = useTranslation();
  return (
    <Stack gap={2}>
      <TextField
        label={t("expertInsights.account.credentials")}
        value={credentials}
        onChange={(e) => onCredentialsChange(e.target.value)}
        size="small"
        fullWidth
        required
        disabled={disabled}
        placeholder={t("expertInsights.account.credentialsPlaceholder")}
        error={Boolean(credentialsError)}
        helperText={credentialsError ?? t("expertInsights.account.credentialsHint")}
      />
      <TextField
        label={t("expertInsights.account.bio")}
        value={bio}
        onChange={(e) => onBioChange(e.target.value)}
        size="small"
        fullWidth
        required
        multiline
        minRows={3}
        disabled={disabled}
        error={Boolean(bioError)}
        helperText={bioError ?? t("expertInsights.account.bioHint")}
      />
    </Stack>
  );
}
